import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

export const InitialForgetPasswordState = {
    company_id: null,
    email: null,
};

export const ForgetPasswordSchema = Yup.object().shape({
    company_id: Yup.number().required(),
    email: Yup.string().required().email(),
});

export const ForgetPasswordFormFields = [
    { name: "company_id", title: "Company", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "email", title: "Email", required: true, type: VALUE_TYPES.TEXT },
];
